module.exports = __webpack_public_path__ + "img/007.50d48421.png";